import { render, staticRenderFns } from "./LeedsCity.vue?vue&type=template&id=36ba1040&scoped=true&"
import script from "./LeedsCity.vue?vue&type=script&lang=js&"
export * from "./LeedsCity.vue?vue&type=script&lang=js&"
import style0 from "./LeedsCity.vue?vue&type=style&index=0&id=36ba1040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba1040",
  null
  
)

export default component.exports